import { render } from "./RecommendEffect.vue?vue&type=template&id=38181112&scoped=true"
import script from "./RecommendEffect.vue?vue&type=script&lang=js"
export * from "./RecommendEffect.vue?vue&type=script&lang=js"

import "./RecommendEffect.vue?vue&type=style&index=0&id=38181112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38181112"]])

export default __exports__